import React from 'react';
import $ from '../../../../offline/jquery.min.js';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { DebounceInput } from 'react-debounce-input';

import Utils from '../../../Services/Utils';

import InputWrapper from '../WrapperInput';
import withShallowComparison from '../../Common/withShallowComparisonUpdate';

class InputNumber extends React.PureComponent {

  constructor(props) {
    super(props);
    this.numberInput = React.createRef();
  }

  componentDidMount() {
    this.initValidate();
    this.setInputFilter(this.numberInput.current, (value) => {
      return /^-?\d*(?:\.\d*)?$/.test(value);
    });
  }

  componentDidUpdate() {
    this.initValidate();
  }

  initValidate = () => {
    const { value, onError, error } = this.props;
    const newError = this.validate(value);
    if (onError && !Utils.equals(newError, error)) onError(newError);
  }

  setInputFilter = (textbox, inputFilter) => {
    ['input', 'keydown', 'keyup', 'mousedown', 'mouseup', 'select', 'contextmenu', 'drop'].forEach(function(event) {
      textbox.addEventListener(event, function() {
        if (inputFilter(this.value)) {
          this.oldValue = this.value;
          this.oldSelectionStart = this.selectionStart;
          this.oldSelectionEnd = this.selectionEnd;
        } else if (this.hasOwnProperty('oldValue')) {
          this.value = this.oldValue;
          this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
        }
      });
    });
  };

  validate = (value) => {
    const { required, validators, minlength, maxlength } = this.props;
    if (required && Utils.isNull(value)) return 'This field is required.';
    if (!Utils.isNull(value) && (value.toString() !== parseFloat(value).toString())) return 'This format is not correct.';
    if (maxlength && (!Utils.isNull(value) && (value.toString().length > parseInt(maxlength)))) {
      return 'This field must have a maximum of ' + maxlength + ' characters';
    }
    if (minlength && (!Utils.isNull(value) && (value.toString().length < parseInt(minlength)))) {
      return 'This field must have a minimum of ' + minlength + ' characters';
    }
    for (const validator of validators || []) {
      if (validator(value)) return validator(value);
    }
    return '';
  };

  handleChange = (e) => {
    const { onChange, onError, error } = this.props;
    let value = e && e.target ? e.target.value : e;
    if (!Utils.isNull(value)) {
      if ((value[0] === '.')) {
        value = '0' + value;
      }
      else if ((value.length > 1) && (value[0] === '-') && (value[1] === '.')) {
        value = '-0.' + value.slice(2,value.length - 1);
      }
    }
    const result = value || null;
    if (onChange) onChange(result);
    const newError = this.validate(result);
    if (onError && !Utils.equals(newError, error)) onError(newError);
  };

  handleKeyDown = (e) => {
    const { onSubmit, value, min, max, maxlength } = this.props;
    if (e.keyCode !== 8) {
      if (e.keyCode === 13) {
        if (onSubmit) onSubmit();
        e.preventDefault();
      }
      else {
        if (Number(value) > Number(max)) {
          e.preventDefault();
          $(this.numberInput.current).val(max);
        }
        if ($(this.numberInput.current).val().toString().length === parseInt(maxlength)) {
          e.preventDefault();
        }
        if ($(this.numberInput.current).val() && (Number(value) < Number(min))) {
          e.preventDefault();
          $(this.numberInput.current).val(min);
        }
      }
    }
  };

  render() {
    const {
      className,
      label,
      labelhtml,
      error,
      placeholder,
      disabled,
      required,
      value,
      debounce
    } = this.props;

    const WrapperProps = {
      className,
      label,
      labelhtml,
      error,
      required,
    };

    const debounceTimeout = !Utils.isNull(debounce) ? debounce : 500;

    return (
      <InputWrapper { ...WrapperProps }>
        <DebounceInput
          inputRef={ this.numberInput }
          debounceTimeout={ debounceTimeout }
          value={ !Utils.isNull(value) ? value : '' }
          onChange={ this.handleChange }
          disabled={ disabled }
          required={ required }
          onKeyDown={ this.handleKeyDown }
          className={ classNames('InputText', {
            InputText_Disabled: Boolean(disabled),
          }) }
          placeholder={ placeholder }
        />
      </InputWrapper>
    );
  }
}

InputNumber.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  min: PropTypes.number,
  max: PropTypes.number,
  minlength: PropTypes.string,
  maxlength: PropTypes.string,
  debounce: PropTypes.number,
  error: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  onChange: PropTypes.func,
  onSubmit: PropTypes.func,
  onError: PropTypes.func,
};

export default withShallowComparison(InputNumber, ['onChange', 'onError']);